var map = {
	"./Concerto 4-5 ottobre.jpg": 9417,
	"./Concerto22Novembre2025.jpg": 2301,
	"./Locandina natale 2.jpg": 9583,
	"./Locandina03012026.jpeg": 293,
	"./Locandina18_04_2026 .jpeg": 9032,
	"./Locandina5x1000.jpeg": 4173,
	"./LocandinaConcerto.jpg": 1453,
	"./LocandinaScuola.jpg": 4691,
	"./LocandinaSottoLeStelle.jpg": 8221,
	"./Natale.jpg": 9894,
	"./colorimusica.jpg": 3445,
	"./concerto-Irsina.jpg": 9581,
	"./concerto-messa.jpg": 5650,
	"./concerto30novembre.jpg": 5877,
	"./concerto9novembre.jpg": 5327,
	"./i colori della musica.jpg": 4590,
	"./locandina10gennaio.jpg": 910,
	"./openday.jpg": 5363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3034;